import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import DataTable, { DataTableProps } from "@insite/mobius/DataTable";
import { DataTableBodyProps } from "@insite/mobius/DataTable/DataTableBody";
import { DataTableCellBaseProps } from "@insite/mobius/DataTable/DataTableCellBase";
import DataTableHead, { DataTableHeadProps } from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader, { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import { DataTableRowProps } from "@insite/mobius/DataTable/DataTableRow";
import { DataTableBody, DataTableCell, DataTableRow } from "@insite/mobius/index";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

export interface ProductDetailsTierPricingStyles {
    table?: DataTableProps;
    tableHead?: DataTableHeadProps;
    breakQtyHeader?: DataTableHeaderProps;
    breakPriceHeader?: DataTableHeaderProps;
    savingsHeader?: DataTableHeaderProps;
    tableBody?: DataTableBodyProps;
    tableRow?: DataTableRowProps;
    breakQtyCell?: DataTableCellBaseProps;
    breakPriceCell?: DataTableCellBaseProps;
    savingsCell?: DataTableCellBaseProps;
    tableCellLabel?: TypographyPresentationProps;
}

export const tierPricingStyles: ProductDetailsTierPricingStyles = {
    table: {
        css: css`
            margin-top: 24px;
        `,
    },
    breakQtyHeader: { alignX: "center" },
    breakPriceHeader: { alignX: "center" },
    savingsHeader: { alignX: "center" },
    breakQtyCell: { alignX: "center" },
    breakPriceCell: { alignX: "center" },
    savingsCell: { alignX: "center" },
    tableCellLabel: {
        size: 16,
    },
};

const styles = tierPricingStyles;

const ProductDetailsTierPricing: React.FC<Props> = ({ productInfo: { pricing }, productInfo }) => {
    if (!pricing?.unitRegularBreakPrices || pricing.unitRegularBreakPrices.length === 0) {
        return null;
    }

    return (
        <DataTable {...styles.table}>
            <DataTableHead {...styles.tableHead}>
                <DataTableHeader {...styles.breakQtyHeader}>
                    {pricing.additionalResults?.minQtyTitle || translate("Min Qty")}
                </DataTableHeader>
                <DataTableHeader {...styles.breakPriceHeader}>
                    {pricing.additionalResults?.pricePerTitle || translate("Price Per")}
                </DataTableHeader>
            </DataTableHead>
            <DataTableBody {...styles.tableBody}>
                {pricing.unitRegularBreakPrices.map(breakPrice => (
                    <DataTableRow {...styles.tableRow} key={breakPrice.breakQty} data-test-selector="breakPriceRow">
                        <DataTableCell {...styles.breakQtyCell} data-test-selector="breakQty">
                            <Typography {...styles.tableCellLabel}>{breakPrice.breakQty}</Typography>
                        </DataTableCell>
                        <DataTableCell {...styles.breakPriceCell} data-test-selector="price">
                            <Typography {...styles.tableCellLabel}>{breakPrice.breakPriceDisplay}</Typography>
                        </DataTableCell>
                    </DataTableRow>
                ))}
            </DataTableBody>
        </DataTable>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsTierPricing),
    definition: {
        displayName: "Tier Pricing",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
